<template>
    <div>
        <v-tabs
            v-model="active_tab"
            slider-color="white"
            style="padding: 10px"
        >
            <v-tabs-slider color="#2196F3"></v-tabs-slider>
            <v-tab v-for="tab of tabs" :key="tab.id" @click="selectTab(tab.id)">
                {{ tab.name }}
            </v-tab>
        </v-tabs>

        <template v-if="active_tab == 0">
            <c-search-form
                :rows-per-page-items="[10, 20, 50]"
                :form-name="formName1"
                :fields="field1"
                key-property="id"
                search-url="/repairRequest/search"
                form-type="intable"
                :customCreateNew="true"
                @createNew="openCreate"
                @viewItem="viewRequest"
                @openRepairDialog="openRepairDialog"
                ref="tableData"
                :reload="timeReload"
                :deleteMulti="false"
                :acceptDelete="false"
                :acceptView="true"
                :acceptEdit="false"
                :acceptCreate="showCreateRequest"
            >
            </c-search-form>
        </template>

        <template v-if="active_tab == 1">
            <c-search-form
                :rows-per-page-items="[10, 20, 50]"
                :form-name="formName3"
                :fields="field3"
                key-property="repairRequestId"
                search-url="/importRepairRequest/search"
                form-type="intable"
                :customCreateNew="true"
                @viewItem="viewImportRepair"
                ref="tableData"
                :reload="timeReload"
                :deleteMulti="false"
                :acceptDelete="false"
                :acceptView="true"
                :acceptEdit="false"
                :acceptCreate="false"
            >
            </c-search-form>
        </template>

        <template v-if="active_tab == 2">
            <c-search-form
                :rows-per-page-items="[10, 20, 50]"
                :form-name="formName2"
                :fields="field2"
                key-property="id"
                search-url="/fixedAssets/detailReport?isRepair=1&"
                form-type="intable"
                :customCreateNew="true"
                @createNew="openCreate"
                @viewItem="viewItem"
                ref="tableData"
                :reload="timeReload"
                :deleteMulti="false"
                :acceptDelete="false"
                :acceptView="true"
                :acceptEdit="false"
                :acceptCreate="false"
            >
            </c-search-form>
        </template>

        <repair-history
            :propsItem="item"
            :dialog="dialogHistory"
            @close="closeDialogHistory"
        />

        <repair-request-create
            :propsItem="itemRequest"
            :dialog="dialogRequest"
            @close="closeDialogRequest"
        />

        <v-dialog max-width="400px" v-model="dialogCreate" persistent>
            <v-card>
                <v-toolbar color="primary" dark>
                    <v-toolbar-title style="padding-left: 0px">
                        Chọn mã quản lý
                    </v-toolbar-title>
                </v-toolbar>
                <v-btn
                    @click="close"
                    icon
                    style="position: absolute;right: 10px;top: 10px;color: #fff;"
                >
                    <v-icon>cancel</v-icon>
                </v-btn>
                <v-form
                    ref="validFormCreate"
                    lazy-validation
                >
                    <v-card-text>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-autocomplete
                                    :items="lstFixedAssets"
                                    label="Mã quản lý"
                                    v-model="fixedAssetsId"
                                    name="fixedAssetsId"
                                    item-value="fixedAssetsId"
                                    item-text="fixedAssetsCode"
                                    v-validate="'required'"
                                    :data-vv-as="$t('Mã quản lý')"
                                    :error-messages="errors.first('fixedAssetsId')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="save">
                            <v-icon dark left>save</v-icon>
                            {{ $t("lang.common.select") }}
                        </v-btn>
                        <v-btn color="error" @click="close">
                            <v-icon dark left>cancel</v-icon>
                            {{ $t("lang.common.cancel") }}
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import { cateContants, requestConstants, roleConstants } from "@/constants";
import axios from "axios";
import { message } from "../../../shared/message";
import RepairHistory from "./RepairHistory.vue";
import RepairRequestCreate from "./RepairRequestCreate.vue";

export default {
    name: "fixed-assets-repair-list",
    components: { CSearchForm, RepairHistory, RepairRequestCreate },
    data: () => {
        return {
            formName1: "Đề nghị sửa chữa",
            formName2: "Lịch sử sửa chữa",
            formName3: "Phiếu nhập lại kho",
            item: null,
            itemRequest: null,
            dialogHistory: false,
            timeReload: 0,
            warehouseId: null,
            lstLocation: [],
            lstDepartment: [],
            lstFixedAssets: [],
            fixedAssetsId: 0,
            fixedAssets: null,
            dialogCreate: false,
            dialogRequest: false,
            lastSearchValues: {},
            active_tab: 0,
            tabs: [
                {id: 1, name: 'Đề nghị sửa chữa'},
                {id: 2, name: 'Phiếu nhập lại kho'},
                {id: 3, name: 'Lịch sử sửa chữa'},
            ],
            field1: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "5%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "repairRequestCode",
                    text: "Số đề nghị",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "fixedAssetsCode",
                    text: "Mã quản lý",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "fixedAssetsName",
                    text: "Tên tài sản",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "createdAt",
                    text: "Ngày tạo đề nghị",
                    headerStyle: "text-align:center",
                    dateFormat: 'dd/MM/yyyy',
                    search: true,
                    type: "datepicker",
                },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: [],
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    width: "10%",
                    sortable: false,
                    compound: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "custom_action_list",
                    text: "Lịch sử sửa chữa",
                    width: "10%",
                    headerStyle: "text-align:center; width: 150px;",
                    items: [
                        {
                            text: "Lịch sử sửa chữa",
                            icon: "build",
                            event: "openRepairDialog",
                            color: "primary"
                        },
                    ],
                },
            ],
            field3: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "5%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "repairRequestCode",
                    text: "Số đề nghị",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "fixedAssetsCode",
                    text: "Mã quản lý",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "fixedAssetsName",
                    text: "Tên tài sản",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "importDate",
                    text: "Ngày nhập kho",
                    headerStyle: "text-align:center",
                    dateFormat: 'dd/MM/yyyy',
                    search: true,
                    type: "datepicker",
                },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: requestConstants.importRepairRequestStatus,
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    width: "10%",
                    sortable: false,
                    compound: true,
                    headerStyle: "text-align:center",
                },
            ],
            field2: [],
        };
    },

    created() {
        this.field2 = [
            {
                value: "index",
                text: "lang.common.index",
                width: "5%",
                sortable: false,
                headerStyle: "text-align:center",
            },
            {
                value: "fixedAssetsCode",
                text: "Mã quản lý",
                sortable: false,
                search: true,
                headerStyle: "text-align:center",
            },
            {
                value: "status",
                text: "lang.user.status",
                search: true,
                headerStyle: "text-align:center",
                type: "select",
                name: "status",
                items: cateContants.fixedAssetsStatus,
                itemText: "text",
                itemValue: "value",
            },
            {
                value: "locationId",
                text: "Địa điểm hiện tại",
                search: true,
                headerStyle: "text-align:center",
                type: "select",
                name: "locationId",
                items: [],
                itemText: "categoryName",
                itemValue: "categoryId",
            },
            {
                value: "departmentId",
                text: "Bộ phận hiện tại",
                search: true,
                headerStyle: "text-align:center",
                type: "select",
                name: "departmentId",
                items: [],
                itemText: "deptName",
                itemValue: "deptId",
            },
            {
                value: "repairCostTotal",
                text: "Chi phí sửa chữa",
                sortable: false,
                search: false,
                headerStyle: "text-align:center;",
                contentStyle: "text-align:right",
                hidden: !this.showPrice,
                type: 'currency',
            },
            {
                value: "action",
                text: "lang.common.actions",
                width: "10%",
                sortable: false,
                compound: true,
                headerStyle: "text-align:center",
            },
        ];

        let queryParam = this.$route.query;
        let activeTab = queryParam.activeTab;
        if(activeTab != undefined){
            this.active_tab = activeTab -1;
        }

        let searchImportRequest = queryParam.searchImportRequest;
        if(searchImportRequest !=undefined){
            try{
                this.lastSearchValues = JSON.parse(searchImportRequest);
            } catch (e){

            }
        }

        this.getLocation();
        this.getDepartment();
        this.getFixedAssets();
        this.setRequestStatus();
    },
    computed: {
        showCreateRequest() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ADMIN) {
                return true;
            } else {
                return false;
            }
        },
        showPrice() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ADMIN) {
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        createParamLastSearch: function (values) {
            const obj1 = {
                searchImportRequest: JSON.stringify(values),
            };
            const obj2 = this.$route.query;
            return {...obj1, ...obj2};
        },
        createParam: function (obj1) {
            const obj2 = this.$route.query;
            return {...obj1, ...obj2};
        },
        closeDialogHistory: function () {
            this.dialogHistory = false;
            this.item = null;
        },
        closeDialogRequest(fixedAssetsId = null) {
            this.timeReload = Math.floor(Math.random() * 100);
            this.dialogRequest = false;
            this.itemRequest = null;
            // console.log(fixedAssetsId);
            if (parseInt(fixedAssetsId) > 0) {
                this.getFixedAssetsById(fixedAssetsId);
            }
        },
        viewItem(item) {
            this.item = item;
            this.dialogHistory = true;
        },
        viewRequest2(item) {
            this.itemRequest = item;
            this.dialogRequest = true;
        },
        viewRequest(item) {
            this.$router.push({path: '/repairRequest/create', query: this.createParam({repairRequestId: item.repairRequestId})});
        },
        viewImportRepair(item) {
            this.$router.push({path: '/importRepairRequest/view', query: this.createParam({importRepairId: item.importRepairId})});
        },
        openRepairDialog(item) {
            this.getFixedAssetsById(item.fixedAssetsId);
            // this.item = item;
            // this.dialogHistory = true;
        },
        getLocation() {
            axios.post(
                    process.env.VUE_APP_API_URL + "/category/listByTypeOrderByCodeAsc?type=OFFICE_LOCATION"
                )
                .then(
                    (data) => {
                        if (data.length > 0) {
                            this.lstLocation = data;
                            let itemFields = this.field2.filter(function (e) {
                                return e.name == "locationId";
                            });
                            if (itemFields != undefined && itemFields.length > 0) {
                                itemFields[0].items = data;
                            }
                        }
                    }
                );
        },
        getDepartment() {
            axios.post(process.env.VUE_APP_API_URL + "/department/search?pageSize=-1&page=-1", {})
            .then(
                (data) => {
                    if (data.items) {
                        this.lstDepartment = data.items;
                        let itemFields = this.field2.filter(function (e) {
                            return e.name == "departmentId";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data.items;
                        }
                    }
                }
            );
        },
        getFixedAssets() {
            axios.post(process.env.VUE_APP_API_URL + "/fixedAssets/detailReport?pageSize=-1&page=-1&isFixing=0", {})
            .then(
                (data) => {
                    if (data.items != undefined && data.items.length > 0) {
                        this.lstFixedAssets = data.items;
                    }
                }
            );
        },
        openCreate2: function () {
            this.dialogCreate = true;
        },
        openCreate: function () {
            this.$router.push({path: '/repairRequest/create', query: this.createParam({})});
        },
        save() {
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    message.error(this.$t("lang.common.validate_fail"));
                    return;
                }
                this.dialogCreate = false;
                this.itemRequest = {fixedAssetsId: this.fixedAssetsId};
                this.dialogRequest = true;
            });
        },
        close() {
            this.dialogCreate = false;
        },
        selectTab(id) {
            this.$router.push({query: {activeTab: id}})
        },
        getFixedAssetsById(fixedAssetsId) {
            axios.post(process.env.VUE_APP_API_URL + "/fixedAssets/detailReport?pageSize=-1&page=-1", {fixedAssetsId: fixedAssetsId})
            .then(
                (data) => {
                    if (data.items != undefined && data.items.length > 0) {
                        this.fixedAssets = data.items[0];
                        this.viewItem(this.fixedAssets);
                    }
                }
            );
        },
        setRequestStatus() {
            let status = requestConstants.repairRequestStatus;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER) {
                status = status.filter(function (e) {
                    return e.value >= 3;
                });
            }

            let itemFields = this.field1.filter(function (e) {
                return e.name == "status";
            });
            if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = status;
            }
        },
    },

    destroyed() {},
};
</script>
